import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  dropDownItem: disabled => ({
    paddingVertical: 8,
    paddingHorizontal: 15,
    width: '100%',
    flexDirection: 'row',
    opacity: disabled || false === true ? 0.3 : 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
  }),
  textContainer: {
    paddingVertical: 10,
    alignContent: 'center',
    flexDirection: 'row',
  },
  text: theme => ({
    color: theme.colors.picker?.itemColor,
    fontSize: 18,
    alignSelf: 'center',
    marginLeft: 16,
  }),
});
